import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref } from 'vue'

import DocumentCommand from '@/components/trip/documents/manager/DocumentCommand.vue'
import DropZone from '@/components/core/DropZone.vue'
import DocumentList from '@/components/trip/documents/manager/DocumentList.vue'
import { useUploadFiles } from '@/composables/file'
import { Document } from '@/types/document'
import { Photo } from '@/types/photo'
import { documentModule } from '@/store'
import { GridContentType, supportedDocumentFileTypes } from '@/utils/enums'
import LButton from '@/components/core/Button.vue'

interface DocumentManagerProps {
  tripId: string
  /**
   * The text to display as the title of the document manager.
   */
  title?: string
  /**
   * A list of documents that are currently managed by this component.
   */
  documents: Document[]
  /**
   * The reference ID for the document manager. This is used to link the
   * documents to a specific entities, like waypoints, accommodations, etc.
   */
  referenceId?: string
  /**
   * The content types of the documents that are supported for upload.
   */
  supportedFileTypes?: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentManager',
  props: {
    tripId: null,
    title: { default: undefined },
    documents: null,
    referenceId: { default: undefined },
    supportedFileTypes: { default: () => Array.from(supportedDocumentFileTypes) }
  },
  emits: ["link", "unlink"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'link', file: Document): void
  (e: 'unlink', id: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tripId: string, title: string, documents: Document[], referenceId: string, supportedFileTypes: string[] };

const documentCommandRef = ref<HTMLElement | null>(null)




documentModule.fetchByTrip(props.tripId)

const showDocumentCommand = ref(false)

const unmanagedFilterCallback = (file: Photo | Document) =>
  !props.documents.find((d) => d._id === file._id)

const managedDocuments = computed(() =>
  documentModule.files.filter((file) =>
    props.documents.find((d) => d._id === file._id),
  ),
)

const unsubscribe = documentModule.store.subscribe((mutation) => {
  if (mutation.type === 'document/addDocument') {
    emit('link', mutation.payload)
  } else if (mutation.type === 'document/removeDocument') {
    emit('unlink', mutation.payload)
  }
})
onBeforeUnmount(unsubscribe)

async function onUploadFiles(event: Event) {
  // check if the event is a drag and drop event
  let files: File[] = []
  if (event instanceof DragEvent && event.dataTransfer?.files) {
    files = Array.from(event.dataTransfer.files)
  }

  // check if the event is a file input change event
  if (
    event instanceof Event &&
    event.target instanceof HTMLInputElement &&
    event.target.files
  ) {
    files = Array.from(event.target.files)
  }

  if (files.length) {
    await useUploadFiles({
      files,
      contentType: GridContentType.DOCUMENT,
      storeModule: documentModule,
      tripId: props.tripId,
    })
  }

  showDocumentCommand.value = false
}

function onLinkFile(file: Document) {
  emit('link', file)
  showDocumentCommand.value = false
}

return { __sfc: true,documentCommandRef, props, emit, showDocumentCommand, unmanagedFilterCallback, managedDocuments, unsubscribe, onUploadFiles, onLinkFile, DocumentCommand, DropZone, DocumentList, LButton }
}

})